import {apsEnums} from "../../shared/dto/aps.enums";
import {SignalRHub} from "../hubs/signalr-hub";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as angular from "angular";
import {Notifications} from "../../models/notifications/notifications";
import HubServiceName, {HubService} from "../hubs/hub.service";

export interface NotificationHubService {
  createNotificationHub(shopId: string,
                        roleId: string,
                        shift: apsEnums.Shift,
                        getNotifications: () => Notifications): NotificationHub;
}

export interface NotificationHub extends SignalRHub {
  stop(): Promise<any>;
  stopNotifications(): Promise<any>;
  getNotifications(data: apsViewModels.NotificationParameters): Promise<any>;
}

export default angular.module('aps.hubs.notification', [HubServiceName])
  .service('notificationHub', function ($timeout: angular.ITimeoutService,
                                        hubService: HubService) {
    let createNotificationHub = function (shopId: string,
                                          roleId: string,
                                          shift: apsEnums.Shift,
                                          getNotifications: () => Notifications): NotificationHub {
      let notificationHub = hubService.createHub<NotificationHub>('notifications', {
        listeners: {
          notificationSent: function (notification) {
            $timeout(() => getNotifications().addNotification(notification));
          },
          notificationRead: function (notification) {
            $timeout(() => getNotifications().markRead(notification));
          },
          notificationCompleted: function (notification) {
            $timeout(() => getNotifications().remove(notification));
          },
          notificationRemoved: function (notification) {
            $timeout(() => getNotifications().remove(notification));
          }
        },
        methods: ['getNotifications', 'stopNotifications'],
        postConnect: (hub: NotificationHub) => {
          hub.invokeWithRetry(() => hub.getNotifications({
            shopId: shopId,
            roleId: roleId,
            shift: shift
          }));
        }
      });

      notificationHub.stop = () => {
        return notificationHub.stopNotifications()
          .then(() => {
            return notificationHub.uninitialize();
          });
      };
      return notificationHub;
    };

    return {
      createNotificationHub: createNotificationHub
    };
  }).name;


// WEBPACK FOOTER //
// ./src/app/services/notifications/notification.hub.ts